export interface PackageModel {
  packageId: string;
  name?: string;
  price: number;
  referencePrice?: number | null;
  contents: any;
  platform: PokerPlatform;
  playType: PlayType;
  fixedExpiryTimestamp?: number;
  isGloballyAssigned: boolean;
  expiresAt: any;
  claimLimit: number
  isBonus: boolean;
}

export interface Package {
  packageId: string;
  name?: string;
  price: number;
  referencePrice?: number | null;
  contents: PackageContentItem[];
  platform: PokerPlatform;
  playType: PlayType;
  fixedExpiryTimestamp?: number;
  isGloballyAssigned: boolean;
  expiresAt: {
    seconds: number;
    nanos: number;
  };
  claimLimit: number
  isBonus: boolean;
}

export interface PackageContents {
  GOLD_COINS: number;
  SWEEPS_COINS?: number;
}

export enum PackageContentType {
  GOLD_COINS = 'GOLD_COINS',
  SWEEPS_COINS = 'SWEEPS_COINS',
  AVATAR = 'AVATAR',
  JSNG_ENTRY = 'JSNG_ENTRY',
  TOURNAMENT_ENTRY = 'TOURNAMENT_ENTRY'
}

export interface GoldCoinsItem {
  type: PackageContentType.GOLD_COINS;
  amount: number;
}

export interface SweepsCoinsItem {
  type: PackageContentType.SWEEPS_COINS;
  amount: number;
}

export interface AvatarItem {
  type: PackageContentType.JSNG_ENTRY;
  nameId: string;
}
export interface JsngEntryItem {
  type: PackageContentType.AVATAR;
  amount: number;
  nameId: string;
}

export interface TournamentEntryItem {
	type: PackageContentType.TOURNAMENT_ENTRY;
	amount: number;
	nameId: string;
}

export type PackageContentItem = GoldCoinsItem | SweepsCoinsItem | AvatarItem | JsngEntryItem | TournamentEntryItem;

export type PokerPlatform = 'GLOBALPOKER_DOT_COM';

export const getSweepsCoinsFromPackageContents = (
	contents: PackageContentItem[],
): SweepsCoinsItem | undefined => {
	return contents.find(
		(i: PackageContentItem) => i.type === PackageContentType.SWEEPS_COINS,
	) as SweepsCoinsItem | undefined
}

export const getGoldCoinsFromPackageContents = (
	contents: PackageContentItem[],
): GoldCoinsItem => {
	return contents.find(
		(i: PackageContentItem) => i.type === PackageContentType.GOLD_COINS,
	) as GoldCoinsItem
}

export const getAvatarFromPackageContents = (
	contents: PackageContentItem[],
): AvatarItem | undefined => {
	return contents.find(
		(i: PackageContentItem) => i.type === PackageContentType.AVATAR,
	) as AvatarItem | undefined
}

export const getJsngEntriesFromPackageContents = (
	contents: PackageContentItem[],
): JsngEntryItem[] | undefined => {
	return contents.filter(
		(i: PackageContentItem) => i.type === PackageContentType.JSNG_ENTRY,
	) as JsngEntryItem[] | undefined
}

export const getTournamentEntriesFromPackageContents = (
	contents: PackageContentItem[],
) : TournamentEntryItem[] | undefined => {
	return contents.filter(
		(i: PackageContentItem) => i.type === PackageContentType.TOURNAMENT_ENTRY,
	) as TournamentEntryItem[] | undefined
}
